import styled from 'styled-components';
import { AgentToolBarStyled } from '../AgentToolBarStyled';

export const AgentToolBarStyledOV = styled(AgentToolBarStyled)`
    background: ${({ theme }) => theme.colors.black2};
`;
